import Maple1 from "./maple (1).webp";
import Maple2 from "./maple (2).webp";

const maple = [Maple1, Maple2];

export default maple;
